module.exports = __webpack_public_path__ + "static/media/logoBlack.2615cad0.png";